
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AbstractCustomerContactFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AbstractCustomerContact"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AbstractContactFragment"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"deliveryType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mailshotRecipient"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"receiveAcknowledgements"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"receiveConformityCertificates"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"receiveDataSheets"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"receiveDeliveryNotes"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"receiveDispatchEmails"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"receiveInvoiceDocuments"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"receiveProformaInvoiceDocuments"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"receiveQuotationDocuments"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"receiveStatementDocuments"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"receiveCreditDocuments"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"receivePaymentReceipts"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"receiveOverdueAccount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"receiveDirectDebitLetters"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"allowPhoneCalls"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"allowMarketing"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"allowFax"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"allowPostalMail"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"webLogin"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":622}};
    doc.loc.source = {"body":"#import 'graphql/fragments/common/AbstractContactFragment.graphql'\n\nfragment AbstractCustomerContactFragment on AbstractCustomerContact {\n  ...AbstractContactFragment\n  deliveryType\n  mailshotRecipient\n  receiveAcknowledgements\n  receiveConformityCertificates\n  receiveDataSheets\n  receiveDeliveryNotes\n  receiveDispatchEmails\n  receiveInvoiceDocuments\n  receiveProformaInvoiceDocuments\n  receiveQuotationDocuments\n  receiveStatementDocuments\n  receiveCreditDocuments\n  receivePaymentReceipts\n  receiveOverdueAccount\n  receiveDirectDebitLetters\n  allowPhoneCalls\n  allowMarketing\n  allowFax\n  allowPostalMail\n  webLogin\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require('graphql/fragments/common/AbstractContactFragment.graphql').definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["AbstractCustomerContactFragment"] = oneQuery(doc, "AbstractCustomerContactFragment");
        
